// UsersCard.js

import React, { useState } from 'react';
import {
  Card,
  CardContent,
  Chip,
  Avatar,
  Typography,
  IconButton,
  Box,
  Stack,
  // Tooltip,
  Divider,
} from '@mui/material';
import GroupIcon from '@mui/icons-material/Group';
// import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import AddIcon from '@mui/icons-material/Add';

import UserDialog from './UserDialog';

export default function UsersCard({ users, handleFilterChange }) {
  const S3_URL = process.env.REACT_APP_S3_URL;
  const user = JSON.parse(localStorage.getItem('user'));
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);

  const handleCloseDialog = () => {
    setTimeout(() => {
      setOpenDialog(false);
      handleFilterChange();
      setSelectedUser(null);
    }, 0);
  };

  return (
    <Card variant="outlined" sx={{ borderRadius: 2 }}>
      <Box
        px={2}
        py={1.5}
        display="flex"
        alignItems="center"
        justifyContent="space-between"
      >
        <Stack direction="row" alignItems="center" spacing={1}>
          <GroupIcon fontSize="small" />
          <Typography variant="subtitle1" fontWeight={500}>
            Usuários ({users.length})
          </Typography>
          {/* <Tooltip title="Meta dos vendedores">
            <HelpOutlineIcon fontSize="small" color="disabled" />
          </Tooltip> */}
        </Stack>

        <IconButton size="small" color="primary">
          <AddIcon onClick={() => {
            setSelectedUser(null);
            setOpenDialog(true);
          }} />
        </IconButton>
      </Box>

      <Divider />

      <CardContent sx={{ pt: 1, pb: 1 }}>
        <Stack spacing={1.5}>
          {users.map((v) => {
            // nao exibe admin se for manager
            if (user.role === 'manager' && v.role === 'admin' && user.name !== 'avex_admin') {
              return null;
            }
            const roleConfig = {
              admin: {
                label: "Admin",
                sx: { backgroundColor: "#ff00007d", color: "#fff" } // vermelho 700
              },
              seller: {
                label: "Vendedor",
                sx: { backgroundColor: "#0080ff7d", color: "#fff" } // azul 700
              },
              manager: {
                label: "Gerente",
                sx: { backgroundColor: "#00610577", color: "#fff" } // verde 700
              },
            };

            return (
            <Box
              key={v.id}
              display="flex"
              alignItems="center"
              sx={{
                p: 1,
                borderRadius: 1.5,
                '&:hover': {
                  backgroundColor: 'action.hover',
                },
              }}
              onClick={() => {
                setSelectedUser(v);
                setOpenDialog(true);
              }}
            >
              <Avatar src={`${S3_URL}/img/user/${v.avatar_url}`} alt={v.name} sx={{ width: 40, height: 40, mr: 1 }} />

              <Box flex={1}>
                <Typography fontWeight={500}>{v.name}</Typography>
                <Chip
                  label={roleConfig[v.role]?.label || v.role}
                  size="small"
                  sx={{
                    ...roleConfig[v.role]?.sx,
                    fontSize: "0.7rem",   // texto menor
                    height: 20,           // altura reduzida
                    padding: "0 4px"      // menos espaço horizontal
                  }}
                />
              </Box>

              {/* Emoji representando a meta */}
              {/* <Box fontSize={22} ml={1}>
                😡
              </Box> */}
            </Box>
          )})}
        </Stack>
      </CardContent>

      <UserDialog 
        openDialog={openDialog}
        setOpenDialog={setOpenDialog}
        handleCloseDialog={handleCloseDialog}
        user={selectedUser}
      />

    </Card>
  );
}
